module.exports = __webpack_public_path__ + "img/CapaInit.7730184c.svg";